import "rc-slider/assets/index.css";
import Slider from "rc-slider";
import * as React from "react";
import "./CareerYearSlider.css";

const CareerYearSlider = (props) => {
    return (
        <div className="career-slider-container">
            <p className="career-slider-text">Please select a year:</p>
            <Slider
                className="career-slider"
                min={0}
                max={5}
                defaultValue={1}
                marks={{ 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }}
                {...props}
            />
        </div>
    )


}

export default CareerYearSlider;